export enum MealType {
  Meat,
  Vegeterian,
}
